export const getStartEndOfMonth = (date: Date = new Date()) => ({
    end: new Date(date.getFullYear(), date.getMonth() + 1, 0),
    start: new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0),
});
